import tournamentsService from '~/services/tournamentService'

export const useTournamentStore = defineStore('TournamentStore', {
  state: () => {
    return {
      tournaments: [],
      popularTournaments: []
    }
  },
  getters: {},
  actions: {
    async fetch () {
      try {
        const { tournaments } = await tournamentsService.fetch()
        this.tournaments = tournaments

        return tournaments
      } catch (e) {
        // $toast.error('Error: ' + e.response.data.error.message)
      }
    },

    async popular () {
      try {
        const { tournaments } = await tournamentsService.popular()
        this.popularTournaments = tournaments

        return tournaments
      } catch (e) {
        // $toast.error('Error: ' + e.response.data.error.message)
      }
    }
  }
})
